import React from "react";
import { useFlutterwave } from "flutterwave-react-v3";
import axios from "axios";
import logo from "./apple-touch-icon.png";
import "./paymentbutton.css";
import { ANONYMOUS_BASE_URL } from "../constant/endpoint";
import { useHistory } from "react-router-dom";
import { pageUrl } from "../constant/pageurl";

export default function PaymentButton(props) {
  const { username, email } = props;

  const history = useHistory();

  const config = {
    public_key: process.env.REACT_APP_PAYMENT_PUBLIC_KEY,
    tx_ref: Date.now(),
    currency: "USD",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: email,
      name: username,
    },
    customizations: {
      logo: { logo },
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  return (
    <button
      className="btn btn-sm upgrade-btn"
      onClick={() => {
        handleFlutterPayment({
          callback: (response) => {
            const { flw_ref, amount } = response;
            // send traction details to the backend
            const newPaymentHistory = {
              username: username,
              tx_ref: flw_ref,
              amount: amount,
              email: email,
            };
            axios
              .post(`${ANONYMOUS_BASE_URL}/subscribe/new`, newPaymentHistory)
              .then((response) => console.log(response))
              .catch((error) => console.log(error));
          },
          onClose: () => {
            history.push(pageUrl.SUBSCRIBE_SUCCESSFUL);
          },
        });
      }}
    >
      click here to upgrade
    </button>
  );
}
